import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import CTABanner from '../../components/CTABanner';
import HeroImage from './HeroImage';
// import HomesMap from './HomesMap';
import HomeProcess from './HomeProcess';
import PhotoGallery from './IndexGallery';
import VideoList from './VideoGalleryList';
import { colors, typography } from '../../styles';


const styles = css`
.ContentBanner {
  padding:60px 0;
}
.ContentBanner_wrapper {
  margin-bottom:60px;
  @media (min-width: 1199px) {
    margin-bottom:60px;
  }
  .ContentBanner_inner {
    display:flex;
    flex-flow:row wrap;
    justify-content:center;
  }
}
.ContentBanner_wrapper:nth-child(odd) {

  .ContentBanner_inner {
    display:flex;
    flex-flow:row-reverse wrap;
    justify-content:center;
  }
}

  .ContentBanner_resultContent {
    display: flex;
    flex-flow:column nowrap;
    justify-content: center;
    width:100%;
    @media (min-width: 1199px) {
      margin: 0;
      padding: 60px 90px;
      width:50%;
    }
  }
  .ContentBanner_heading {
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    font-family: ${typography.Serif};
    color: ${colors.color2};
    margin: 0 0 45px 0;
    position: relative;
    @media (min-width: 992px) {
      font-size: 44px;
    }
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 60px;
      height: 6px;
      left: 0;
      bottom: -22px;
      background-color: ${colors.color1};
    }
  }
  .ContentBanner_preHeading {
    font-weight: 300;
    display: block;
    font-size: 18px;
    text-transform: uppercase;
    @media (min-width: 992px) {
      font-size: 24px;
    }
  }
  .ContentBanner_body {
    width: 100%;
  }
  .ContentBanner_resultMedia {
    width:100%;
    min-height:250px;
    background-size:cover;
    background-position:center;
    display:block;
    margin-bottom:20px;
    @media (min-width: 1199px) {
      width:50%;
      min-height:400px
      margin-bottom:0'
    }
  }
`;


function Index({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <HeroImage page={page} />
      <HomeProcess />
      {
        get(page, 'home_content') &&
        <div className="ContentBanner">
          {
            get(page, 'home_content').map((item, index) => (
              <div className="ContentBanner_wrapper container">
                <div className="ContentBanner_inner">
                  <div className="ContentBanner_resultMedia" style={{ backgroundImage: `url(${buildThumbnailUrl(item.image.contentUrl, { width: 1000, height: 1000, preserve: true })})` }} />
                  <div className="ContentBanner_resultContent">
                    {
                      !index &&
                        <h1 className="ContentBanner_heading">
                          <span className="ContentBanner_preHeading">{item.pre_title}</span>
                          {item.title}
                        </h1>
                    }
                    {
                      !!index &&
                        <h2 className="ContentBanner_heading">
                          <span className="ContentBanner_preHeading">{item.pre_title}</span>
                          {item.title}
                        </h2>
                    }
                    <div className="ContentBanner_body" dangerouslySetInnerHTML={SanitizeHtml(item.body)} />
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      }
      <CTABanner />
      <PhotoGallery page={page} />
      {
        get(page, 'video_list[0]') &&
        <VideoList videos={get(page, 'video_list')} videoCount={6} />
      }
    </PageWrapper>
  );
}

Index.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  areas: true,
  communities: true,
  homes: true,
  plans: true,
  page: 'home_page',
})(Index);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/index.js